import styled, { keyframes, css } from 'styled-components'
import wave1 from './Images/wave1.svg'
import wave2 from './Images/wave2.svg'
import wave3 from './Images/wave3.svg'

const chevronArrowAnimation = keyframes`
  0%{
    transform: translateX(0px)
  }
  100%{
    transform: translateX(5px)
  }
`

const section = css`
  padding: 32px 48px;
  color: ${({ theme }) => theme.colors.text.text900};
  transition: all 0.2s;

  @media (max-width: 600px) {
    padding: 16px;
  }
`

const sectionHeading = css`
  text-transform: capitalize;
  text-align: center;
  line-height: 1.33;
  font-size: 25px;
  transition: all 0.2s;

  span:last-of-type {
    margin-left: 8px;
  }
  @media (max-width: 600px) {
    font-size: 21px;
  }
`

const createNewNovel = css`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: capitalize;
  height: 64px;
  width: 100%;
  max-width: 360px;
  background-color: #068ae2;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 700;
  color: var(--bg-alt);
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
  -webkit-tap-highlight-color: transparent;
  margin: 0px auto;

  svg {
    margin-left: 16px;
    animation: ${chevronArrowAnimation} 0.25s linear infinite alternate;
  }
`

const Container = styled.div`
  background-color: var(--bg-alt);
  width: 100%;
`

const WritersBenefitHeader = styled.header`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: var(--Raven);
  color: var(--clay-text-clay-700);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 48px;
  transition: all 0.2s;

  @media (max-width: 700px) {
    padding: 16px 8px;
    flex-direction: ${({isUserFromUS}) => isUserFromUS ? 'column' : 'row'};
    align-items: ${({isUserFromUS}) => isUserFromUS ? 'flex-start' : 'center'};
  }
`

const WritersBenefitHeaderLinks = styled.div`

@media (max-width: 700px) {

  ${({isUserFromUS}) => isUserFromUS ? 'display:grid':''};
  ${({isUserFromUS}) => isUserFromUS ? 'grid-template-columns:1fr 1fr':''};
  ${({isUserFromUS}) => isUserFromUS ? 'width:100%':''};

}
`

const WritersBenefitHeaderLink = styled.a`
  color: inherit;
  margin: 0px 16px;
  cursor: pointer;
  text-transform: capitalize;
  transition: all 0.2s;
  &:last-of-type {
    border: ${({isUserFromUS}) => isUserFromUS ? "none" : "1px solid #62667c"};
    border-radius: ${({isUserFromUS}) => isUserFromUS ? "0px" : "4px"};
    padding: 6px 8px;
    margin-right: 0px;
  }

  @media (max-width: 700px) {
    margin: 0px 8px;
    font-size: 12px;
    width: 50%;
    ${({isUserFromUS}) => isUserFromUS ? 'width:100%':''};
    ${({isUserFromUS}) => isUserFromUS ? 'margin:16px auto':''};

    &:last-of-type {
    ${({isUserFromUS}) => isUserFromUS ? 'padding:0px':''};
  }
  }
`

const WritersBenefitProgramNotification = styled.div`
  color: var(--bg-alt);
  background-color: var(--DarkGrey300);
  padding: 8px 48px;
  transition: all 0.2s;

  @media (max-width: 600px) {
    padding: 8px;
  }
`

const Notification = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  max-width: 600px;
  border-radius: 4px;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border: 1px solid var(--corn-700);
  -webkit-tap-highlight-color: transparent;

  svg {
    margin-right: 16px;
  }
`

const NotificationText = styled.p`
  &::first-letter {
    text-transform: uppercase;
  }
`

const Banner = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  justify-items: end;
  align-items: center;
  min-height: 300px;
  color: var(--bg-alt);
  position: relative;
  padding: 32px 10vw;
  padding-bottom: 0px;
  background-color: var(--DarkGrey300);
  transition: all 0.2s;

  @media (max-width: 770px) {
    padding: 16px;
    padding-right: 0px;
    justify-items: normal;
    height: auto;
  }
`

const BannerTextContainer = styled.div`
  width: 100%;
  transition: all 0.2s;
  @media (max-width: 600px) {
    width: 150px;
  }
`

const BannerHeading = styled.h2`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin: 8px auto;
  transition: all 0.2s;
  @media (max-width: 770px) {
    font-size: 20px;
  }
`

const BannerSubHeading = styled.h3`
  text-transform: uppercase;
  border-radius: 4px;
  background-color: #363b50;
  padding: 8px;
  font-size: 18px;
  letter-spacing: 4px;
  margin: 16px 0px;
  width: max-content;
`

const BannerSVGContainer = styled.div`
  overflow: hidden;
  svg {
    max-width: 418px;
    width: 100%;
    height: 300px;
  }
  @media (max-width: 900px) {
    overflow: hidden;
    svg {
      width: 244px;
      height: 166px;
    }
  }
`
const BannerCreateNovelBtn = styled.button`
  ${createNewNovel}
  z-index: 1;
  margin: 0px;
  transition: all 0.2s;
  padding: 12px;
  @media (max-width: 600px) {
    position: absolute;
    bottom: -32px;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
  }
`

const RewardsAndBenefits = styled.div`
  margin-top: 0px;
  ${section}
  background: ${({isUserFromUS}) => isUserFromUS ? `url(${"https://djhonz7dexnot.cloudfront.net/e45be9e8e77377b3f3938242de93b1d938e1944c.jpg"}) center/cover no-repeat` : `url(${wave1}) top/cover no-repeat`};
  transition: all 0.2s;
  @media (max-width: 600px) {
    margin-top: 32px;
    background: var(--bg-alt);
  }
`

const RewardsAndBenefitsHeading = styled.h2`
  ${sectionHeading}
  margin-top: 48px;
  transition: all 0.2s;
  color: ${({isUserFromUS}) => isUserFromUS ? '#0350A2' : '#0d1536'};
  @media (max-width: 600px) {
    margin-top: 0px;
    color: #0d1536;
  }
`

const RewardsAndBenefitsSubHeading = styled.p`
  text-align: center;
  margin: 16px auto;
  color: ${({isUserFromUS}) => isUserFromUS ? '#0350A2' : `var(--Text500)`};
  &::first-letter{
    text-transform: capitalize;
  }
  @media (max-width: 600px) {
    color: var(--Text500);
  }
`

const RewardsAndBenefitsCardsContainer = styled.div`
  margin: 32px auto;
  display: flex;
  flex-wrap: ${({isUserFromUS}) => isUserFromUS ? 'wrap':'nowrap'};
  max-width: ${({isUserFromUS}) => isUserFromUS ? '1000px' : '100%'};
  flex-direction: ${({isUserFromUS}) => isUserFromUS ? 'column':'row'};
  align-items: ${({isUserFromUS}) => isUserFromUS ? 'center':'flex-start'};
  transition: all 0.2s;
  @media (max-width: 600px) {
    flex-direction: column;
    flex-wrap: nowrap;
    margin: 16px auto;
  }
`

const RewardsAndBenefitsCardsWrapper = styled.div`
  border:${({isUserFromUS}) => isUserFromUS ? '1px solid #78B3EE': 'none'};
  border-radius:${({isUserFromUS}) => isUserFromUS ? '8px': '0px'};
  margin: 16px auto;
  display: grid;
  grid-template-columns: ${({isUserFromUS}) => isUserFromUS ? "50% 50%" : "1fr"};
  width: 100%;
  padding: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    margin: 0px auto;
    padding: 16px 0px;
    border:none;
  }

`

const RewardsAndBenefitsImage = styled.img`
  width: 300px;
  height: 300px;
  display: block;

  @media (max-width: 600px) {
    display: none;
  }

`

const RewardsAndBenefitsCards = styled.div`
  border-radius: 4px;
  background-color: ${({isUserFromUS}) => isUserFromUS ? 'transparent':'var(--bg-alt)'};
  padding: 16px;
  max-width: ${({isUserFromUS}) => isUserFromUS ? '700px':'350px'};
  box-shadow:${({isUserFromUS, theme}) => isUserFromUS ? 'none':`0 0 8px 0 ${theme.colors.text.textMuted16}`};
  transition: all 0.2s;
  @media (max-width: 600px) {
    box-shadow: none;
    margin: auto;
    background: linear-gradient(
      180deg,
      rgba(240, 241, 245, 0) 0%,
      #f0f1f5 100%
    );
  }
`

const RewardsAndBenefitsCardsHeading = styled.h3`
  text-transform: capitalize;
  text-align: center;
  background-color: ${({isUserFromUS}) => isUserFromUS ? '#ffffff':'var(--azure-op-16)'};
  border-radius: 4px;
  font-weight: 600;
  color: ${({isUserFromUS}) => isUserFromUS ? 'var(--azure-800)':'var(--Text500)'};
  line-height: 28.8px;
  padding: 12px 20px;
  margin: 16px auto;

  @media (max-width: 600px) {
    background-color: var(--azure-op-16);
    color: var(--Text500);
  }

`

const RewardsAndBenefitsCardsSubHeading = styled.p`
  color: var(--Text500);
  text-align: center;
`

const RewardsAndBenefitsTable = styled.table`
  border: 1px solid;
  width: 90%;
  line-height: 36px;
  margin: 16px auto;
  border-collapse: collapse;

  ${({isUserFromUS}) => isUserFromUS ? 'table-layout: fixed;width: max-content;' : ''};

  th,
  td {
    padding: ${({isUserFromUS}) => isUserFromUS ? '0px 16px' :'8px'};
    border: 1px solid var(--Text500);
    text-align: left;
  }
  th {
    color: ${({ theme }) => theme.colors.text.text900};
    font-weight: 700;
    line-height: 1.6;
  }
  td {
    color: var(--Text500);
    font-weight: 600;
    ${({isUserFromUS}) => isUserFromUS ? 'white-space: nowrap;':''};
  }

  tr:first-child th {
    border-top-color: transparent;
  }
  tr:last-child td {
    border-bottom-color: transparent;
  }
  tr td:first-child,
  tr th:first-child {
    border-left-color: transparent;
  }
  td{
    border-bottom-color: ${({isUserFromUS}) => isUserFromUS ? 'transparent' : 'inherit'};
  }
  tr td:last-child,
  tr th:last-child {
    border-right-color: transparent;
  }

  @media (max-width: 600px) {
    width: 100%;
  }

`

const RewardsAndBenefitsNote = styled.div`
  display: grid;
  grid-template-columns: minmax(24px, 34px) auto;
  justify-content: center;
  gap: 8px;
  align-items: center;
  margin: 16px auto;
  font-weight: 600;
`

const RewardsAndBenefitsNoteText = styled.p`
  color:var(--Text500);
  font-weight: 400;
  & strong{
    color: ${({isUserFromUS}) => isUserFromUS ? '#B88214' : 'inherit'};
  }
`

const RewardsAndBenefitsData = styled.div`
  align-self: center;
  overflow: hidden;
  justify-self:center ;

  @media (max-width: 600px) {
    display: none;
  }

`

const CardChevronBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  width: 24px;
  height: 24px;
  display: block;
  margin: 0px auto;
  color: var(--Text500);
  -webkit-tap-highlight-color: transparent;

  &.open {
    transform: rotate(180deg);
  }
`

const RewardsAndBenefitsNoteList = styled.ol`
  margin: 0px auto;
  width: 90%;
  line-height: 26px;
  color: var(--Text500);
  max-height: 0;
  overflow: hidden;
  list-style-position: inside;
  transition: max-height 0.25s ease-out;
`

const RewardsAndBenefitsCreateNovelBtn = styled.button`
  ${createNewNovel}
`

const ProgramDeadline = styled.div`
  ${section}
`

const ProgramDeadlineHeading = styled.h2`
  ${sectionHeading}
`
const ProgramDeadlineSub = styled.p`
  text-align: center;
  margin: 16px auto;
`

const ProgramDeadlineText = styled.p`
  text-align: center;
  margin: 16px auto;
  font-size: 18px;
  color: var(--Text500);
  font-weight: ${({isUserFromUS}) => isUserFromUS ? 'bold':'normal'};
`
const ProgramDeadlineCreateNewNovelBtn = styled.button`
  ${createNewNovel}
  padding: 12px;
`

const ProgramDeadlineCautionText = styled.p`
  border:1px solid var(--corn-op-24);
  background-color:var(--corn-op-8) ;
  color: var(--corn-800);
  border-radius: 4px;
  margin: 16px auto;
  padding: 8px 16px;
  max-width: 360px;
  text-align: center;
  font-weight: 600;
`

const HowItWorks = styled.div`
  ${section}
  background: ${({isUserFromUS}) => isUserFromUS ? `#CCF5FD` : `url(${wave2}) top/cover no-repeat`};
  transition: all 0.2s;
  @media (max-width: 600px) {
    background: var(--bg-alt);
  }
`

const PocketInTheNews = styled.div`
  ${section}
  background:linear-gradient(180deg, #BFEDFF 0%, #CCF5FD 25%) center/cover no-repeat;
  @media (max-width: 600px) {
    background: #F0F0F0;
  }
`

const PocketInTheNewsHeading = styled.h2`
  ${sectionHeading}
  margin-top: 48px;
  transition: all 0.2s;
  @media (max-width: 600px) {
    margin-top: 0px;
  }
`

const HowItWorksHeading = styled.h2`
  ${sectionHeading}
  margin-top: 48px;
  transition: all 0.2s;
  @media (max-width: 600px) {
    margin-top: 0px;
  }
`

const HowItWorksMobileCard = styled.div`
  border: 1px solid var(--Fjord500);
  border-radius: 8px;
  background-color: var(--bg-alt);
  padding: 16px;
  text-align: center;
  margin: 16px auto;
`
const PocketInNewsMobileCard = styled.div`
  border-radius: 8px;
  text-align: center;
  margin: 16px auto;
`

const HowItWorksCardIconContainer = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 4px;
  background-color: var(--azure-300);
  color: var(--bg-alt);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px auto;
  svg {
    width: 44px;
    height: 44px;
  }
`

const HowItWorksCardHeading = styled.h3`
  text-transform: uppercase;
  color: #0d1536cc;
  font-size: 18px;
  text-align: center;
  background-color: rgba(102, 205, 246, 0.15);
  border: 1px solid var(--azure-300);
  padding: 8px;
  width: 80px;
  border-radius: 4px;
  margin: 0px auto;
`

const HowItWorksCardText = styled.p`
  color: var(--Text500);
  margin: 16px auto;
  line-height: 26px;
  width: 80%;
  min-height: auto;
  text-align: center;
  transition: all 0.2s;

  @media (max-width: 600px) {
    min-height: 132px;
  }
`

const HowItWorksBtnContainer = styled.div`
  margin: 16px auto 0px;
  background-color: rgb(62 68 94);
  border-radius: 20px;
  max-width: 160px;
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
`
const PocketInTheNewsBtnContainer = styled.div`
  margin: 16px auto 0px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  max-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
`

const HowItWorksBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 15px;
  height: 15px;
  transform: scale(${({ isActive }) => (isActive ? 1.4 : 1)});
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  color: ${({ isActive }) =>
    isActive ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s;
`
const PocketInTheNewsBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 4px;
  background: ${({ isActive }) =>
    isActive ? '#206CC6' : '#D9D9D9'};
  
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s;
`

const HowItWorksCardsContainer = styled.div`
  padding: 16px;
  margin: 16px auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  justify-items: center;

  @media (max-width: 768px){
    grid-template-columns: 1fr;
  }
`

const PocketInTheNewsCardsContainer = styled.div`
  padding: 16px;
  margin: 16px auto;
`

const HowItWorksCard = styled.div`
  max-width: 380px;
`

const PocketInTheNewsCard=styled.a`
  display: flex;
  align-items:center ;
  cursor: pointer;
  margin:0px auto 32px;
  max-width: 880px;
  &:last-of-type{
    margin-bottom: 0px;
  }
`

const PocketInTheNewsImage=styled.img`
width: 280px;
height: 170px;
border-radius: 4px;
margin-right: 32px;

  @media (max-width: 768px){
    margin:8px auto;
    width:100%;
    max-width: 360px;
    height: 170px;
  }
`

const PocketInTheNewsContent=styled.div``

const PocketInTheNewsDate =styled.p`
  color: rgba(13, 21, 54, 0.65);
  font-size: 12px;

`

const PocketInTheNewsTitle = styled.h3`
  margin: 8px auto;
  color: rgba(13, 21, 54, 0.8);
`

const PocketInTheNewsBrief = styled.p`
  color: rgba(13, 21, 54, 0.65);
  & a{
    color: inherit;
  }
 & span{
  color: rgba(13, 21, 54, 0.4);
  font-weight: bold ;
 }
`

const HowItWorksCreateNovelBtn = styled.button`
  ${createNewNovel}
  background-color: var(--bg-alt);
  color: ${({ theme }) => theme.colors.text.text900};
`

const PopularWriters = styled.div`
  ${section}
  background: linear-gradient(180deg, #f6f7f9 0%, #f0f1f5 100%);
`

const PopularWritersHeading = styled.h2`
  ${sectionHeading}
`

const PopularWritersCardsContainer = styled.div`
  margin: 32px auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 800px;
  transition: all 0.2s;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const PopularWritersCards = styled.div`
  display: flex;
  align-items: center;
  margin: 16px auto;
  min-width: 290px;
`

const WriterImgContainer = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-right: 16px;
  box-shadow: inset 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
`

const WriterImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  border-radius: inherit;
  box-shadow: inherit;
`

const InfoContainer = styled.div`
  color: var(--Text700);
`

const WriterName = styled.p`
  text-transform: capitalize;
`

const NovelName = styled.p`
  span {
    text-transform: capitalize;
  }
`

const NovelDetails = styled.p`
  font-weight: 700;
`
const FrequentlyAskedQuestions = styled.div`
  ${section}
  background: linear-gradient(180deg, #eefaff 0%, #ccf5fd 100%);
  transition: all 0.2s;
  @media (max-width: 600px) {
    background: var(--bg-alt);
  }
`

const FrequentlyAskedQuestionsHeading = styled.h2`
  ${sectionHeading}
`
const AccordionContainer = styled.div`
  margin: 32px auto;
  max-width: 800px;
  transition: all 0.2s;

  @media (max-width: 600px) {
    margin: 32px auto;
  }
`

const Accordion = styled.div`
  margin: 16px auto;
`

const AccordionText = styled.div`
  max-height: 0;
  overflow: hidden;
  color: var(--Text500);
  transition: max-height 0.25s ease-out;

  &::first-letter {
    text-transform: capitalize;
  }
`

const AccordionBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &::first-letter {
    text-transform: capitalize;
  }
  &:after {
    content: '+';
    font-size: 20px;
    color: #000000;
    margin-left: 8px;
    float: right;
  }
  &.open:after {
    content: '-';
  }
`

const WriteAtHome = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-items: end;
  ${section}
  padding: 48px 10vw;
  min-height: 300px;
  padding-bottom: 0px;
  background: url(${wave3}) top/cover no-repeat;
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.2s;

  @media (max-width: 770px) {
    background: var(--DarkGrey300);
    grid-template-columns: 100%;
    padding: 16px;
    justify-items: normal;
    height: auto;
  }
`

const WriteAtHomeHeading = styled.h2`
  ${sectionHeading}
  text-align: left;
  transition: all 0.2s;
  @media (max-width: 770px) {
    text-align: center;
  }
`

const WriteAtHomeText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  line-height: 26px;
  margin: 16px auto;
  transition: all 0.2s;
  @media (max-width: 770px) {
    text-align: center;
  }
`

const WriteAtHomeTextContainer = styled.div`
  width: 100%;
`

const WriteAtCreateNovelBtn = styled.button`
  ${createNewNovel}
  margin: 0px;
  transition: all 0.2s;
  @media (max-width: 770px) {
    margin: 0px auto;
  }
`

const WriteAtSVGContainer = styled.div`
  overflow: hidden;
  transition: all 0.2s;
  align-self: end;
  svg {
    width: 280px;
    height: 220px;
    transition: all 0.2s;
  }
  @media (max-width: 900px) {
    margin: 32px auto 0px;
    svg {
      width: 244px;
      height: 166px;
    }
  }
`
const ProgramDeadlineSubHeading = styled.p`
border: 1px solid var(--corn-op-24);
    background-color: var(--corn-op-8);
    color: var(--corn-800);
    border-radius: 4px;
    margin: 16px auto;
    padding: 8px 16px;
    max-width: 360px;
    text-align: center;
    font-weight: 600;
`;

const WriteAtHomeNote = styled.p`
  margin: 24px auto;
  color: #F2C602;
  line-height: 24px;
`


const ModalIframe = styled.iframe`
    width: 100%;
    height: 100%;
`

export {
  Container,
  ModalIframe,
  RewardsAndBenefitsImage,
  RewardsAndBenefitsCardsWrapper,
  WritersBenefitHeader,
  WritersBenefitHeaderLinks,
  WritersBenefitHeaderLink,
  Banner,
  Notification,
  ProgramDeadlineSub,
  WritersBenefitProgramNotification,
  NotificationText,
  BannerTextContainer,
  BannerSVGContainer,
  BannerHeading,
  BannerSubHeading,
  BannerCreateNovelBtn,
  RewardsAndBenefits,
  RewardsAndBenefitsHeading,
  RewardsAndBenefitsSubHeading,
  RewardsAndBenefitsCardsHeading,
  RewardsAndBenefitsCardsSubHeading,
  RewardsAndBenefitsCards,
  RewardsAndBenefitsData,
  RewardsAndBenefitsCardsContainer,
  RewardsAndBenefitsCreateNovelBtn,
  RewardsAndBenefitsTable,
  RewardsAndBenefitsNote,
  RewardsAndBenefitsNoteText,
  CardChevronBtn,
  RewardsAndBenefitsNoteList,
  ProgramDeadline,
  ProgramDeadlineCautionText,
  ProgramDeadlineHeading,
  ProgramDeadlineText,
  ProgramDeadlineCreateNewNovelBtn,
  HowItWorks,
  HowItWorksHeading,
  HowItWorksCard,
  HowItWorksMobileCard,
  HowItWorksCardIconContainer,
  HowItWorksCardHeading,
  HowItWorksCardText,
  HowItWorksBtnContainer,
  HowItWorksBtn,
  HowItWorksCardsContainer,
  HowItWorksCreateNovelBtn,
  PopularWriters,
  PopularWritersHeading,
  PopularWritersCardsContainer,
  PopularWritersCards,
  WriterImgContainer,
  WriterImg,
  InfoContainer,
  WriterName,
  NovelName,
  NovelDetails,
  FrequentlyAskedQuestions,
  FrequentlyAskedQuestionsHeading,
  AccordionContainer,
  Accordion,
  AccordionText,
  AccordionBtn,
  WriteAtHome,
  WriteAtHomeHeading,
  WriteAtHomeText,
  WriteAtHomeTextContainer,
  WriteAtCreateNovelBtn,
  WriteAtSVGContainer,
  ProgramDeadlineSubHeading,
  WriteAtHomeNote,
  PocketInTheNewsHeading,
  PocketInTheNews,
  PocketInTheNewsCardsContainer,
  PocketInTheNewsCard,
  PocketInTheNewsImage,
  PocketInTheNewsContent,
  PocketInTheNewsDate,
  PocketInTheNewsTitle,
  PocketInTheNewsBrief,
  PocketInNewsMobileCard,
  PocketInTheNewsBtnContainer,
  PocketInTheNewsBtn
}
